<template>
  <g>
    <path
      d="M21 8.00018C19.55 8.00018 18.74 9.44018 19.07 10.5102L15.52 14.0702C15.22 13.9802 14.78 13.9802 14.48 14.0702L11.93 11.5202C12.27 10.4502 11.46 9.00018 10 9.00018C8.55 9.00018 7.73 10.4402 8.07 11.5202L3.51 16.0702C2.44 15.7402 1 16.5502 1 18.0002C1 19.1002 1.9 20.0002 3 20.0002C4.45 20.0002 5.26 18.5602 4.93 17.4902L9.48 12.9302C9.78 13.0202 10.22 13.0202 10.52 12.9302L13.07 15.4802C12.73 16.5502 13.54 18.0002 15 18.0002C16.45 18.0002 17.27 16.5602 16.93 15.4802L20.49 11.9302C21.56 12.2602 23 11.4502 23 10.0002C23 8.90018 22.1 8.00018 21 8.00018Z"
    />
    <path
      d="M15 9.00018L15.94 6.93018L18 6.00018L15.94 5.07018L15 3.00018L14.08 5.07018L12 6.00018L14.08 6.93018L15 9.00018Z"
    />
    <path
      d="M3.5 11.0002L4 9.00018L6 8.50018L4 8.00018L3.5 6.00018L3 8.00018L1 8.50018L3 9.00018L3.5 11.0002Z"
    />
  </g>
</template>
